import { render, staticRenderFns } from "./DeActiveProcessMaster.vue?vue&type=template&id=687bc204&scoped=true&"
import script from "./DeActiveProcessMaster.vue?vue&type=script&lang=js&"
export * from "./DeActiveProcessMaster.vue?vue&type=script&lang=js&"
import style0 from "./DeActiveProcessMaster.vue?vue&type=style&index=0&id=687bc204&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687bc204",
  null
  
)

export default component.exports